import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Button,
  Space,
  Image,
  Modal,
  message,
  Spin,
  Card,
  Layout,
  Typography
} from "antd";
import { CheckOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../Config";
import Sidebar from "../Components/Sidebar";

import { MenuOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const AdminMediaLink = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [viewOpen, setViewOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const [filter, setFilter] = useState("pending"); // pending | approved

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    fetchPromotionRequests(filter);
  }, [filter]);

  const fetchPromotionRequests = async (selectedFilter = filter) => {
    try {
      setLoading(true);

      const url =
        selectedFilter === "paid"
          ? `${BASE_URL}/promoteimgs?type=paid`
          : `${BASE_URL}/promoteimgs`;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setData(res.data?.data || []);
    } catch (err) {
      message.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  const handleViewImages = async (id) => {
    try {
      setViewOpen(true);
      setImageLoading(true);

      const res = await axios.get(`${BASE_URL}/promoteimgs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setImages(res.data.data?.promotionImgs || []);
    } catch (err) {
      message.error("Failed to load images");
    } finally {
      setImageLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await axios.put(
        `${BASE_URL}/promoteimgs/promotion-approve/${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      message.success("Promotion approved");
      fetchPromotionRequests();
    } catch (err) {
      message.error("Approval failed");
    }
  };

  const handleReject = async (id) => {
    try {
      await axios.put(
        `${BASE_URL}/admin/promotion-reject/${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      message.success("Promotion rejected");
      fetchPromotionRequests();
    } catch (err) {
      message.error("Rejection failed");
    }
  };

  const filteredData =
    filter === "paid"
      ? data
      : data.filter((item) => {
        if (filter === "pending")
          return item.mediaLinkAction === "promotion_pending";

        if (filter === "approved")
          return item.mediaLinkAction === "completed";

        return true;
      });

  const columns = [
    {
      title: "Variation",
      dataIndex: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Asana",
      dataIndex: ["parentAsana", "name"],
    },
    {
      title: "User",
      render: (_, record) => (
        <>
          <div>{record.user?.name}</div>
          <small style={{ color: "#888" }}>{record.user?.email}</small>
        </>
      ),
    },
    {
      title: "Pose Type",
      dataIndex: "poseType",
      render: (types) =>
        types?.map((t, i) => (
          <Tag color="blue" key={i}>
            {t}
          </Tag>
        )),
    },
    {
      title: "Status",
      dataIndex: "mediaLinkAction",
      render: (status) => {
        if (status === "promotion_pending") {
          return <Tag color="orange">Promotion Pending</Tag>;
        }
        if (status === "completed") {
          return <Tag color="green">Approved</Tag>;
        }
        return <Tag>—</Tag>;
      },
    },
    {
      title: "Images",
      render: (_, record) => (
        <Button
          icon={<EyeOutlined />}
          onClick={() => handleViewImages(record._id)}
        >
          View
        </Button>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => {
        if (filter === "paid") {
          return <Tag color="blue">Paid User</Tag>;
        }

        const isPending = record.mediaLinkAction === "promotion_pending";

        return (
          <Space>
            {isPending ? (
              <>
                <Button
                  type="primary"
                  icon={<CheckOutlined />}
                  onClick={() => handleApprove(record._id)}
                >
                  Approve
                </Button>

                <Button
                  danger
                  icon={<CloseOutlined />}
                  onClick={() => handleReject(record._id)}
                >
                  Reject
                </Button>
              </>
            ) : (
              <Tag color="green">Completed</Tag>
            )}
          </Space>
        );
      },
    },
  ];

  const MobilePromotionCard = ({ item }) => {

    const isApproved =
      item.mediaLinkAction === "completed";

    const isPending =
      item.mediaLinkAction === "promotion_pending";

    return (

      <Card
        style={{
          marginBottom: 16,
          borderRadius: 18,
        }}
        bodyStyle={{
          padding: 14,
        }}
      >

        {/* Top Row */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >

          <Space>

            <Image
              src={item.image}
              width={60}
              height={60}
              style={{
                borderRadius: 12,
                objectFit: "cover",
              }}
            />

            <div>

              <div
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                }}
              >
                {item.name}
              </div>

              <div
                style={{
                  fontSize: 13,
                  color: "#777",
                }}
              >
                {item.poseType?.join(", ")}
              </div>

            </div>

          </Space>


          {/* Status */}

          <Tag
            color="green"
            style={{
              borderRadius: 20,
              padding: "4px 14px",
            }}
          >
            {isApproved
              ? "APPROVED"
              : "PENDING"}
          </Tag>

        </div>


        {/* Media Link Status */}

        <div style={{ marginTop: 10 }}>

          <Tag color="blue">
            {item.mediaLinkStatus || "expired"}
          </Tag>

        </div>


        {/* Actions */}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 14,
          }}
        >

          <Button
            icon={<EyeOutlined />}
            shape="round"
            onClick={() =>
              handleViewImages(item._id)
            }
          />

          {isPending && (

            <>
              <Button
                icon={<CheckOutlined />}
                type="primary"
                shape="round"
                style={{
                  background: "#10b981",
                  borderColor: "#10b981",
                }}
                onClick={() =>
                  handleApprove(item._id)
                }
              />

              <Button
                icon={<CloseOutlined />}
                danger
                shape="round"
                onClick={() =>
                  handleReject(item._id)
                }
              />

            </>

          )}

        </div>

      </Card>

    );
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />
      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header
          className="MainHeader"
        >
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>
              <Header
                className="MainHeader"
              >
                {isMobile && (
                  <Button
                    type="text"
                    icon={<MenuOutlined />}
                    onClick={() => setMobileOpen(true)}
                    style={{ fontSize: 18, marginRight: 12 }}
                  />
                )}
                <div style={{ flex: 1 }}>
                  <Text style={{ fontSize: 20, fontWeight: "bold" }}>Media Link</Text>
                </div>
              </Header>
            </Text>
          </div>
        </Header>
        <Card
          title="Media Link status"
          extra={
            isMobile ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type={filter === "pending" ? "primary" : "default"}
                  onClick={() => setFilter("pending")}
                >
                  Pending
                </Button>

                <Button
                  type={filter === "approved" ? "primary" : "default"}
                  onClick={() => setFilter("approved")}
                >
                  Approved
                </Button>

                <Button
                  type={filter === "paid" ? "primary" : "default"}
                  onClick={() => setFilter("paid")}
                >
                  Paid Variations
                </Button>
              </div>
            ) : (

              <Space>
                <Button
                  type={filter === "pending" ? "primary" : "default"}
                  onClick={() => setFilter("pending")}
                >
                  Pending
                </Button>

                <Button
                  type={filter === "approved" ? "primary" : "default"}
                  onClick={() => setFilter("approved")}
                >
                  Approved
                </Button>

                <Button
                  type={filter === "paid" ? "primary" : "default"}
                  onClick={() => setFilter("paid")}
                >
                  Paid Variations
                </Button>
              </Space>
            )
          }
        >
          {
            isMobile ? (

              loading ? (
                <Spin />
              ) : (

                filteredData.map(item => (
                  <MobilePromotionCard
                    key={item._id}
                    item={item}
                  />
                ))

              )

            ) : (

              <Table
                columns={columns}
                dataSource={filteredData}
                rowKey="_id"
                loading={loading}
                pagination={{ pageSize: 5 }}
              />

            )
          }
        </Card>

        <Modal
          title="Promotion Images"
          open={viewOpen}
          onCancel={() => setViewOpen(false)}
          footer={null}
          width={800}
          centered
        >
          {imageLoading ? (
            <Spin />
          ) : (
            <Space wrap>
              {images.length ? (
                images.map((img, i) => (
                  <Image
                    key={i}
                    src={img}
                    width={200}
                    style={{ borderRadius: 8 }}
                  />
                ))
              ) : (
                <p>No images found</p>
              )}
            </Space>
          )}
        </Modal>
      </Layout>
    </Layout>
  );
};

export default AdminMediaLink;
